var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBarbell = function SvgIconBarbell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    clipPath: "url(#icon-barbell_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 24h1.5M15 18h-3a1.5 1.5 0 0 0-1.5 1.5v9A1.5 1.5 0 0 0 12 30h3M15 16.5v15a1.5 1.5 0 0 0 1.5 1.5H18a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 18 15h-1.5a1.5 1.5 0 0 0-1.5 1.5ZM19.5 24h9M28.5 16.5v15A1.5 1.5 0 0 0 30 33h1.5a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5H30a1.5 1.5 0 0 0-1.5 1.5ZM33 18h3a1.5 1.5 0 0 1 1.5 1.5v9A1.5 1.5 0 0 1 36 30h-3M39 24h-1.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-barbell_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h36v36H6z"
  })))));
};
export default SvgIconBarbell;